import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useDispatch } from 'react-redux'
import { reduxBatch } from '@manaflair/redux-batch'
import { jobSettingsActions, settingsActions } from '../../../store/slices'

import { ANSI_TPI, CONNECTION_TYPE } from '../../../common/constants'
import { countryOptions } from '../../../common/json/common.json'
import { COUNTRY } from '../../../../../utils/constants'
import { useModal } from '../../../../../utils/hooks'

import { ButtonGroup, Modal } from '../../../../../components'
import { useCalcActions } from '../../../common/hooks'

const CountrySelection = ({ country, connectionType }) => {
  const dispatch = useDispatch()

  const [show, toggleModal] = useModal(false)

  const countryIcon = useMemo(() => {
    return countryOptions.find((element) => element.value === country)?.imgSrc ?? ''
  }, [country])

  const { updateCalcValue } = useCalcActions(jobSettingsActions)

  const handleSelectCountry = (name, value) => {
    reduxBatch([
      dispatch(
        settingsActions.updateCalculation({
          [name]: value,
        }),
      ),
      updateCalcValue({
        ansitpi: ANSI_TPI[value],
        upliftLoadDurationType: value === COUNTRY.USA ? 160 : 115,
        downloadDurationType:
          value === COUNTRY.USA ? (connectionType === CONNECTION_TYPE.JOIST ? 100 : 125) : 100,
      }),
    ])

    toggleModal()
  }

  return (
    <div>
      <a role="button" onClick={toggleModal} className="btn--round btn__country">
        <img src={countryIcon} alt="country-icon" />
      </a>

      <Modal
        show={show}
        onHide={toggleModal}
        className="modal__country-selector"
        header={
          <Modal.Header closeButton>
            <h3>Select Your Country</h3>
          </Modal.Header>
        }
      >
        <ButtonGroup
          className="buttonGroup row -skinny -subAppSelector"
          colClassName="col-xxs-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 -skinny"
          name="country"
          value={country}
          options={countryOptions}
          onChange={handleSelectCountry}
        />
      </Modal>
    </div>
  )
}

CountrySelection.propTypes = {
  country: PropTypes.string.isRequired,
  connectionType: PropTypes.string.isRequired,
}

export default CountrySelection
